(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tapi-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initCarousel(root) {
      if (root.__tapiCarouselWired) return;
      root.__tapiCarouselWired = true;

      var slides = root.querySelectorAll('.tapi-hero__slide');
      var dots = root.querySelectorAll('.tapi-hero__dot');
      var fill = root.querySelector('.tapi-hero__progress-fill');
      if (slides.length <= 1) return;

      var interval = Math.max(2500, parseInt(root.getAttribute('data-interval'), 10) || 5000);
      var autoplay = root.getAttribute('data-autoplay') === '1' && !reduceMotion;
      var current = 0;
      var timer = null;
      var paused = false;
      var inView = false;

      // A slide is "video-driven" when it holds a playable hero video for the
      // current viewport. The carousel then does NOT advance on the fixed
      // interval — it holds, and the video module calls __tapiHeroAdvance() once
      // the clip ends. This getter is installed by initHeroVideo; on an
      // image-only hero it's absent and treated as false (plain timer behaviour).
      function videoDriven() {
        return !!(root.__tapiHeroVideoActive && root.__tapiHeroVideoActive());
      }
      function clearTimer() { if (timer) { clearTimeout(timer); timer = null; } }

      function setActive(idx) {
        var next = ((idx % slides.length) + slides.length) % slides.length;
        if (next === current) return;
        slides[current].classList.remove('is-active');
        if (dots[current]) {
          dots[current].classList.remove('is-active');
          dots[current].setAttribute('aria-selected', 'false');
        }
        current = next;
        slides[current].classList.add('is-active');
        if (dots[current]) {
          dots[current].classList.add('is-active');
          dots[current].setAttribute('aria-selected', 'true');
        }
        // Empty the progress bar. scheduleNext() animates it for image slides;
        // the video module drives it from playback for video slides.
        if (fill) { fill.style.transition = 'none'; fill.style.width = '0%'; fill.offsetWidth; }
        if (root.__tapiHeroVideoSync) root.__tapiHeroVideoSync();
      }

      // Hand off from the current slide to the next:
      //  - video-driven -> no timer; the video's 'ended' calls __tapiHeroAdvance
      //  - image slide  -> animate the progress fill, advance after `interval`
      function scheduleNext() {
        clearTimer();
        if (!autoplay || paused || document.hidden || !inView) return;
        if (videoDriven()) return; // the video owns the advance and drives `fill`
        if (fill) {
          fill.style.transition = 'none';
          fill.style.width = '0%';
          // eslint-disable-next-line no-unused-expressions
          fill.offsetWidth; // reflow so the next transition runs
          fill.style.transition = 'width ' + interval + 'ms linear';
          fill.style.width = '100%';
        }
        timer = setTimeout(advance, interval);
      }
      function advance() { setActive(current + 1); scheduleNext(); }
      function stop() {
        clearTimer();
        if (fill) { fill.style.transition = 'none'; fill.style.width = '0%'; }
      }

      // Bridges the video module uses (guarded there, since the carousel bails
      // out early on a single-slide hero and never defines these):
      root.__tapiHeroAdvance = advance;          // video 'ended' -> next slide
      root.__tapiHeroReschedule = scheduleNext;  // re-decide after a source swap / failure
      root.__tapiHeroIsPaused = function () { return paused || document.hidden; };

      // Dot clicks
      Array.prototype.forEach.call(dots, function (d) {
        d.addEventListener('click', function () {
          setActive(parseInt(d.getAttribute('data-idx'), 10) || 0);
          scheduleNext();
        });
      });

      // Pause on hover (desktop) — halts the timer and the active video alike.
      if (window.matchMedia('(hover: hover)').matches) {
        root.addEventListener('mouseenter', function () {
          paused = true; clearTimer();
          if (root.__tapiHeroVideoSync) root.__tapiHeroVideoSync();
        });
        root.addEventListener('mouseleave', function () {
          paused = false;
          if (root.__tapiHeroVideoSync) root.__tapiHeroVideoSync();
          scheduleNext();
        });
      }

      // Pause on tab hidden
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) clearTimer(); else scheduleNext();
        if (root.__tapiHeroVideoSync) root.__tapiHeroVideoSync();
      });

      // Keyboard navigation when dots are focused
      Array.prototype.forEach.call(dots, function (d) {
        d.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { setActive(current + 1); scheduleNext(); }
          else if (e.key === 'ArrowLeft') { setActive(current - 1); scheduleNext(); }
        });
      });

      // Touch swipe (mobile)
      var touchStartX = null;
      root.addEventListener('touchstart', function (e) {
        if (e.touches && e.touches.length === 1) touchStartX = e.touches[0].clientX;
      }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (touchStartX === null || !e.changedTouches || !e.changedTouches.length) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 40) {
          setActive(current + (dx < 0 ? 1 : -1));
          scheduleNext();
        }
        touchStartX = null;
      }, { passive: true });

      // Lazy-start when scrolled into view. The FIRST start is held until the
      // page has loaded and settled (~1s) so the hero stays still through first
      // paint — a calmer, more deliberate first impression, and it keeps the
      // initial render visually stable (better Speed Index). Re-entry (scrolling
      // back into view) starts immediately; manual dots/swipe are never gated.
      var autoplayArmed = false;
      function beginAutoplay() {
        inView = true;
        if (autoplayArmed) { scheduleNext(); return; }
        autoplayArmed = true;
        var go = function () { scheduleNext(); };
        if (document.readyState === 'complete') { setTimeout(go, 1000); }
        else { window.addEventListener('load', function () { setTimeout(go, 1000); }, { once: true }); }
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) beginAutoplay();
            else { inView = false; stop(); }
          });
        }, { threshold: 0.15 });
        io.observe(root);
      } else {
        beginAutoplay();
      }
    }

    // Responsive hero video. Decoupled from the carousel so it works on single-slide
    // heroes too. Wires up ONLY if a slide actually has a <video> — image-only heroes
    // pay zero cost. Loads the source for the CURRENT viewport only (never both), and
    // plays just the active, in-view slide. Falls back to the still <picture> under
    // reduced-motion or when a viewport has no video set.
    function initHeroVideo(root) {
      if (root.__tapiHeroVideoWired) return;
      var vids = root.querySelectorAll('.tapi-hero__video');
      if (!vids.length) return;
      root.__tapiHeroVideoWired = true;

      var multi = root.querySelectorAll('.tapi-hero__slide').length > 1;
      var fill = root.querySelector('.tapi-hero__progress-fill');
      var desktopMQ = window.matchMedia('(min-width: 990px)');
      var inView = true;

      function isPaused() { return root.__tapiHeroIsPaused ? root.__tapiHeroIsPaused() : document.hidden; }
      function srcFor(v) {
        return desktopMQ.matches
          ? (v.getAttribute('data-src-desktop') || '')
          : (v.getAttribute('data-src-mobile') || '');
      }
      function activeSlide() { return root.querySelector('.tapi-hero__slide.is-active'); }
      function slideOf(v) { return v.closest('.tapi-hero__slide'); }

      // The carousel checks this before each auto-advance. True = the active
      // slide has a real, playable video for THIS viewport, so the carousel holds
      // and lets the clip finish instead of advancing on its fixed timer.
      root.__tapiHeroVideoActive = function () {
        if (reduceMotion) return false;
        var a = activeSlide();
        if (!a) return false;
        var v = a.querySelector('.tapi-hero__video');
        if (!v || v.__playFailed) return false;
        return !!srcFor(v);
      };

      function loadAndPlay(v) {
        if (reduceMotion) return;
        var src = srcFor(v);
        if (!src) { pause(v); return; }          // no video for this viewport → picture shows
        v.loop = !multi;                         // single-slide loops; multi plays once, then advances
        if (v.getAttribute('data-loaded-src') !== src) {
          v.src = src;
          v.setAttribute('data-loaded-src', src);
          v.load();
        }
        var p = v.play();
        if (p && p.catch) p.catch(function () {
          // Autoplay blocked — don't strand the carousel waiting on this slide.
          v.__playFailed = true;
          if (root.__tapiHeroReschedule) root.__tapiHeroReschedule();
        });
        v.classList.add('is-playing');
      }
      function pause(v) {
        v.classList.remove('is-playing');
        try { v.pause(); } catch (e) {}
      }
      function sync() {
        var active = activeSlide();
        Array.prototype.forEach.call(vids, function (v) {
          if (inView && !isPaused() && slideOf(v) === active) loadAndPlay(v);
          else pause(v);
        });
      }
      // Let the carousel's setActive re-evaluate which video should be playing.
      root.__tapiHeroVideoSync = sync;

      Array.prototype.forEach.call(vids, function (v) {
        // A finished clip on a multi-slide hero advances to the next slide —
        // this is what makes the carousel wait for the video instead of the timer.
        v.addEventListener('ended', function () {
          if (multi && slideOf(v) === activeSlide() && root.__tapiHeroAdvance) root.__tapiHeroAdvance();
        });
        // A broken source must not hang the carousel — fall back to the timer.
        v.addEventListener('error', function () {
          v.__playFailed = true;
          if (slideOf(v) === activeSlide() && root.__tapiHeroReschedule) root.__tapiHeroReschedule();
        });
        // While it's the active video, it drives the progress bar so the bar
        // tracks real remaining time rather than the fixed interval.
        v.addEventListener('timeupdate', function () {
          if (!fill || reduceMotion) return;
          if (slideOf(v) !== activeSlide() || !srcFor(v)) return;
          var d = v.duration;
          if (!d || !isFinite(d)) return;
          fill.style.transition = 'width 0.25s linear';
          fill.style.width = Math.min(100, (v.currentTime / d) * 100) + '%';
        });
      });

      // Crossing the 990px boundary swaps to the other viewport's source, which
      // can change whether this slide is video-driven — re-sync, clear any stale
      // failure flag, then let the carousel re-decide timer vs video.
      function onMQ() {
        Array.prototype.forEach.call(vids, function (v) { v.__playFailed = false; });
        sync();
        if (root.__tapiHeroReschedule) root.__tapiHeroReschedule();
      }
      if (desktopMQ.addEventListener) desktopMQ.addEventListener('change', onMQ);
      else if (desktopMQ.addListener) desktopMQ.addListener(onMQ);

      // Pause while off-screen (saves battery/data), resume on return.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { inView = entry.isIntersecting; sync(); });
        }, { threshold: 0.15 }).observe(root);
      }
      sync();
    }

    function boot() {
      document.querySelectorAll('[data-tapi-carousel]').forEach(function (c) {
        initCarousel(c);
        initHeroVideo(c);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var c = e.target.querySelector('[data-tapi-carousel]');
      if (c) {
        c.__tapiCarouselWired = false;
        c.__tapiHeroVideoWired = false;
        initCarousel(c);
        initHeroVideo(c);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tapi-watch-buy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Coverflow controller: the tile whose centre is nearest the rail's centre
    // becomes .is-active — scaled up, and its inline muted clip plays. All other
    // clips pause and reset. Tapping still opens the full-screen story player
    // (handled by tapi-story.js via [data-story-tile]); this only manages the
    // resting/active look + inline autoplay. Scroll-driven so it needs no fixed
    // index math and works for any clip count.
    function initStage(stage) {
      if (!stage || stage.__wbInit) return;
      stage.__wbInit = true;
      var rail = stage.querySelector('[data-wb-rail]');
      if (!rail) return;
      var cells = Array.prototype.slice.call(rail.querySelectorAll('.tapi-watchbuy__cell'));
      if (!cells.length) return;
      var prevBtn = stage.querySelector('[data-wb-prev]');
      var nextBtn = stage.querySelector('[data-wb-next]');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // Bandwidth tier from the Network Information API (where supported):
      //   'save' = Data Saver on, or 2g -> no inline autoplay (poster + tap to open)
      //   'lite' = 3g                    -> autoplay the light 480p clip, no preloading
      //   'full' = 4g / unknown          -> autoplay + preload neighbours for instant snaps
      function netTier() {
        var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        if (!c) return 'full';
        if (c.saveData) return 'save';
        var t = c.effectiveType || '';
        if (t === 'slow-2g' || t === '2g') return 'save';
        if (t === '3g') return 'lite';
        return 'full';
      }
      var tier = netTier();
      // Inline preview only has the one heavy mp4 rendition Liquid exposes, so
      // autoplay it only on a fast link. On 3g/2g/Save-Data the active tile stays a
      // poster with a visible play button; tapping opens the full-screen player.
      var noAuto = reduce || tier !== 'full';
      if (noAuto) stage.classList.add('wb-nodata');
      var keepRadius = tier === 'full' ? 1 : 0;  // how many neighbours keep their buffer

      var active = -1;
      var raf = 0;

      function playCell(cell) {
        var v = cell.querySelector('[data-wb-video]');
        var tile = cell.querySelector('.tapi-watchbuy__tile');
        if (!v || !tile) return;
        var src = tile.getAttribute('data-video');
        if (src && !v.getAttribute('src')) { v.setAttribute('preload', 'auto'); v.setAttribute('src', src); }
        v.muted = true;
        // Cross-fade the clip in only once real frames are ready, so the poster
        // holds instead of flashing black — smooth and premium.
        var reveal = function () { v.classList.add('is-playing'); };
        v.addEventListener('playing', reveal, { once: true });
        var p = v.play();
        if (p && p.catch) p.catch(function () { v.removeEventListener('playing', reveal); });
      }
      function stopCell(cell) {
        var v = cell.querySelector('[data-wb-video]');
        if (!v) return;
        v.classList.remove('is-playing');
        try { v.pause(); } catch (e) {}
      }
      // Free the buffer of clips far from the active one: mobile browsers cap how
      // many videos can hold data at once, and 9 buffered clips turns janky. Only
      // the active clip (+ neighbours on fast links) keeps its src.
      function releaseCell(cell) {
        var v = cell.querySelector('[data-wb-video]');
        if (!v) return;
        v.classList.remove('is-playing');
        try { v.pause(); } catch (e) {}
        if (v.getAttribute('src')) { v.removeAttribute('src'); try { v.load(); } catch (e) {} }
      }
      function preloadNeighbour(i) {
        if (tier !== 'full' || i < 0 || i >= cells.length) return;
        var cell = cells[i];
        var v = cell.querySelector('[data-wb-video]');
        var tile = cell.querySelector('.tapi-watchbuy__tile');
        if (!v || !tile) return;
        var src = tile.getAttribute('data-video');
        if (src && !v.getAttribute('src')) { v.setAttribute('preload', 'metadata'); v.setAttribute('src', src); }
      }
      function syncBuffers() {
        for (var i = 0; i < cells.length; i++) {
          if (Math.abs(i - active) > keepRadius) releaseCell(cells[i]);
        }
      }

      function update() {
        raf = 0;
        var r = rail.getBoundingClientRect();
        var mid = r.left + r.width / 2;
        var best = 0, bestDist = Infinity;
        for (var i = 0; i < cells.length; i++) {
          var c = cells[i].getBoundingClientRect();
          var d = Math.abs((c.left + c.width / 2) - mid);
          if (d < bestDist) { bestDist = d; best = i; }
        }
        if (best === active) return;
        if (active > -1 && cells[active]) { cells[active].classList.remove('is-active'); stopCell(cells[active]); }
        active = best;
        cells[active].classList.add('is-active');
        if (!noAuto) playCell(cells[active]);
        preloadNeighbour(active - 1);
        preloadNeighbour(active + 1);
        syncBuffers();
        if (prevBtn) prevBtn.disabled = active <= 0;
        if (nextBtn) nextBtn.disabled = active >= cells.length - 1;
      }
      function onScroll() { if (!raf) raf = requestAnimationFrame(update); }

      function scrollToCell(i) {
        i = Math.max(0, Math.min(i, cells.length - 1));
        var target = cells[i];
        var r = rail.getBoundingClientRect();
        var c = target.getBoundingClientRect();
        var delta = (c.left + c.width / 2) - (r.left + r.width / 2);
        rail.scrollBy({ left: delta, behavior: reduce ? 'auto' : 'smooth' });
      }

      rail.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      if (prevBtn) prevBtn.addEventListener('click', function () { scrollToCell(active - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollToCell(active + 1); });

      // Pause every inline clip when the section scrolls out of view (perf).
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { if (active > -1 && !noAuto) playCell(cells[active]); }
            else { cells.forEach(stopCell); }
          });
        }, { threshold: 0.2 }).observe(stage);
      }

      // Initial position: DON'T centre the first clip (that leaves a big empty gap
      // beside it on wide screens, where the coverflow's side padding sits). Instead
      // centre the clip that has just enough tiles to its left to fill the start, so
      // the row reads full from the left edge. Earlier clips stay reachable — scroll
      // left to bring the first clip to centre (the empty space beside it then is
      // expected) or tap any tile for the full-screen player. Clamped so small clip
      // counts still keep a tile on the right.
      function initPosition() {
        var colW = cells[0].getBoundingClientRect().width || 1;
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        var fitLeft = Math.round((rail.clientWidth / 2) / (colW + gap));
        var startIndex = Math.max(0, Math.min(fitLeft, Math.max(0, cells.length - 2)));
        if (startIndex <= 0) { update(); return; }
        var rr = rail.getBoundingClientRect();
        var cr = cells[startIndex].getBoundingClientRect();
        rail.scrollLeft += (cr.left + cr.width / 2) - (rr.left + rr.width / 2);
        update();
      }
      initPosition();
      // Re-run after paint in case fonts/layout shift the measurements.
      requestAnimationFrame(function () { update(); });
    }

    function boot() {
      document.querySelectorAll('[data-watchbuy]').forEach(initStage);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
